import { ExperimentTrackingData } from "@rea-argonaut/experiment";

type ActiveExperiment = ExperimentTrackingData & { variation: string };

export type ExperimentsSchema = {
  experiments: {
    schema: "iglu:au.com.realestate/experiments/jsonschema/1-0-0";
    data: {
      experiments: {
        experiment_id: string;
        variant: string;
        section: string;
      }[];
    };
  };
};

const experimentToTracking = ({
  experimentId,
  variation,
  section,
}: ActiveExperiment) => ({
  experiment_id: experimentId,
  variant: variation,
  section,
});

const getExperimentsData =
  (experiments: ExperimentTrackingData[]) =>
  (): ExperimentsSchema | Record<string, never> => {
    const userIsBucketedIntoExperiment = (
      experiment: ExperimentTrackingData,
    ): experiment is ActiveExperiment => experiment.variation !== null;

    const activeExperiments = experiments
      .filter(userIsBucketedIntoExperiment)
      .map(experimentToTracking);

    return activeExperiments.length !== 0
      ? {
          experiments: {
            schema: "iglu:au.com.realestate/experiments/jsonschema/1-0-0",
            data: { experiments: activeExperiments },
          },
        }
      : {};
  };

export default getExperimentsData;
